import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import {
  SliderThemes,
  SliderNavigationPositions
} from '@dcxwam/dcx-wam-ui-foundations'
import { slidesArray } from '../Slides/Slides'
import { canUseDom } from '../../../../utils/isSsr'
import { EditableComponentPropsType } from '../../../../utils/prop-types'
import { SliderVariantProps } from '../types'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../../utils/aem/editor/extractEditableProps'
import { NoSsr } from '../../../functional/NoSsr/NoSsr'
import { getSliderComponent } from '../common/getSliderComponent'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../../functional/ErrorBoundary'
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
canUseDom && import('@dcxwam/dcx-wam-ui-foundations/css')

const SliderVariantB: React.FC<EditableComponentPropsType<SliderVariantProps>> =
  withComponentRefresh((props) => {
    const {
      id,
      background,
      theme,
      accessibilityFirst,
      accessibilityLast,
      accessibilityNext,
      accessibilityPrevious,
      adaptiveHeight,
      xfPath,
      ...rest
    } = props.model
    const editableProps = useExtractEditableProps(props, rest)

    const slides = slidesArray(props)

    let sliderTheme = SliderThemes.Light
    switch (theme) {
      case 'light':
        sliderTheme = SliderThemes.Light
        break
      case 'dark':
        sliderTheme = SliderThemes.Dark
        break
      default:
        break
    }

    const configSliderB = {
      navigationPosition: SliderNavigationPositions.Top,
      background,
      centeredSlides: false,
      slides,
      sliderTheme,
      lazyLoading: true,
      keyboard: true,
      className: 'slider-b',
      autoHeight: adaptiveHeight,
      minHeightSlideWidth: true,
      accessibilityProps: {
        firstSlideMessage: accessibilityFirst,
        lastSlideMessage: accessibilityLast,
        prevSlideMessage: accessibilityPrevious,
        nextSlideMessage: accessibilityNext
      }
    }

    const componentToDisplay = getSliderComponent({
      props,
      xfPath,
      sliderConfig: configSliderB
    })

    return (
      <NoSsr>
        <EditableComponent {...editableProps}>
          {componentToDisplay}
        </EditableComponent>
      </NoSsr>
    )
  })

const SliderVariantBWithErrorBoundary = withErrorBoundary(SliderVariantB, {
  componentName: 'SliderVariantB',
  fallback: <ErrorFallback componentName="SliderVariantB" />
})

export default SliderVariantBWithErrorBoundary
